// =====================================
//  更改商品規格 modal
//
//  @author: Gray
//  @time 2016 / 09 / 01
// =====================================

window.InifECMobileApp.directive('changeOrderitemSpec', ['$rootScope', '$ngModal', '$timeout', 'ProductService', 'ShoppingCartService', '$ProductFormatService',
    function ($rootScope, $ngModal, $timeout, ProductService, ShoppingCartService, $ProductFormatService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var getPdtClassList = function(orderitem) {
                if($scope.isLoading || $scope.isLoaded) {
                    return;
                }

                $scope.isLoading = true;
                ProductService.getPdtClassList().then(function(result) {
                    if(result) {

                        $scope.pdtClassList = $ProductFormatService.getPdtClassList('MOBILE_FULL');

                        if(!$scope.pdtClassList || $scope.pdtClassList.length == 0) {
                            var _result = shallowCopy(result);

                            $scope.pdtClassList = $ProductFormatService.formatMobileFullPdtClassList(_result);
                        }

                        if($scope.pdtClassList.length > 0) {
                            getOrderItem(orderitem);
                        }
                    }

                    $scope.isLoaded = true;
                    $scope.isLoading = false;
                }, function(error) {
                    $scope.isLoading = false;
                    $scope.isError = true;
                });
            }
            
            var getOrderItem = function(orderitem) {

                for(var i = 0; i < $scope.pdtClassList.length; i++) {

                    var mainPdtClass = $scope.pdtClassList[i];

                    for(var j = 0; j < mainPdtClass.pdtClasses.length; j++) {

                        var pdtClass = mainPdtClass.pdtClasses[j];

                        if(orderitem.pdtClass == pdtClass.pdtClass) {

                            // 複合商品找法不同
                            if(orderitem.complexidList && orderitem.complexidList.length > 0) {
                                if(getComplexOrderItem(orderitem, mainPdtClass, pdtClass)) {
                                    return;
                                }
                            } else {
                                for(var k = 0; k < pdtClass.products.length; k++) {
                                    var product = pdtClass.products[k];
                                    if(orderitem.productid == product.productid) {
                                        $scope.form.mainPdtClass = mainPdtClass;
                                        $scope.form.pdtClass = pdtClass;
                                        $scope.form.product = product;
                                        return;
                                    }
                                }
                            }                            
                        }
                    }
                }
            }

            var getComplexOrderItem = function(orderitem, mainPdtClass, pdtClass) {

                for(var i = 0; i < pdtClass.products.length; i++) {
                    var product = pdtClass.products[i];

                    if(product.complex && product.complex.productList && product.complex.productList.length > 0) {
                        for(var j = 0; j <  product.complex.productList.length; j++) {
                            var complexPdt = product.complex.productList[j];
                            if(orderitem.productid == complexPdt.productid) {
                                $scope.form.mainPdtClass = mainPdtClass;
                                $scope.form.pdtClass = pdtClass;
                                
                                var _product = shallowCopy(product);

                                complexPdt.name = _product.name;
                                complexPdt.complex = _product.complex;
                                complexPdt.isComplex = _product.isComplex;

                                $scope.form.product = complexPdt;
                                return true;
                            }
                        }
                    }
                }

                return false;
            }

            // -------------------------------
            // 離開更改商品規格
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            //  開啟 modal
            // -------------------------------
            var openModal = function() {

                $ngModal.openModal('change-orderitem-spec-modal');
            }

            // -------------------------------
            //  關閉 modal
            // -------------------------------
            var closeModal = function() {

                $ngModal.closeModal('change-orderitem-spec-modal');
            }

            var init = function(orderitem) {
                if($scope.isLoaded){
                    getOrderItem(orderitem);
                    return;
                }

                getPdtClassList(orderitem);
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_CHANGE_ORDERITEM_SPEC_MODAL', function(event, data) {
                
                if(data) {
                    $scope.form.mainPdtClass = undefined;
                    $scope.form.pdtClass = undefined;
                    $scope.form.product = undefined;
                    $scope.orderitem = shallowCopy(data.orderitem);
                    $scope.callback = data.callback;
                    // console.log($scope.orderitem)
                    $timeout(function() {
                        init($scope.orderitem);
                        openModal();    
                    })
                    
                }
            });

            $scope.$on("ON_CHANGE_ORDERITEM_SUCCESS", function(event, data){
                if(data) {
                    var orderitemid = $scope.orderitem.orderitemid,
                        productid = data.product.productid,
                        spec = data.spec,
                        processRemark = data.processRemark,
                        supplier = data.supplier;

                    $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                        title: '正在更改規格',
                    });

                    ShoppingCartService.changeShoppingCartItem(
                        orderitemid, productid, spec, processRemark, supplier, ShoppingCartService.cartTypeMap.defaultCart
                    ).then(function(result) {

                        if(result) {
                            $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                                title: '成功更改規格',
                            });
                            ($scope.callback) && $scope.callback(result);
                            closeModal();
                        } else {
                            $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                                title: '系統發生錯誤',
                            });
                        }
                    }, function(error) {
                        $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                            title: '系統發生錯誤',
                        });
                    })
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.isLoading = false;
            $scope.isLoaded = false;
            $scope.pdtClassList = [];
            $scope.orderid = undefined;
            $scope.orderitem = undefined;
            $scope.form = {
                mainPdtClass: undefined,
                pdtClass: undefined,
                product: undefined,
                // function
                changeOrderitem: undefined,
            };

            /*==========================
                Methods
            ==========================*/
            $scope.cancel = cancel; // 離開更改商品規格
            $scope.callback;

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/change_orderitem_spec.html";
        _dir.controller = controller;

        return _dir;
    }]
);